import * as React from "react";
import AppBar from "@mui/material/AppBar";
import Box from "@mui/material/Box";
import CssBaseline from "@mui/material/CssBaseline";
import Divider from "@mui/material/Divider";
import Drawer from "@mui/material/Drawer";
import IconButton from "@mui/material/IconButton";
import List from "@mui/material/List";
import ListItem from "@mui/material/ListItem";
import ListItemButton from "@mui/material/ListItemButton";
import ListItemText from "@mui/material/ListItemText";
import MenuIcon from "@mui/icons-material/Menu";
import Toolbar from "@mui/material/Toolbar";
import Typography from "@mui/material/Typography";
import {
  Button,
  Modal,
  Grid,
  Select,
  MenuItem,
  FormControl,
  InputLabel,
} from "@mui/material";
import { useNavigate, useLocation, Link as RouterLink } from "react-router-dom";
import { getEmail, saveTargetPath } from "../utils/storage";
import Popover from "@mui/material/Popover";
import { useFeatureFlag } from "@harnessio/ff-react-client-sdk";
import { Link } from "@mui/material";
import { useSelector } from "react-redux";
import { useDispatch } from "react-redux";
import { setUserStatus } from "../redux/action/user";
import { Auth } from "aws-amplify";
import { OAuthCtx } from "../auth/AuthContext";
import { setupAuthInterceptor } from "../utils/apis";
import UserDropdown from "./common/UserDropdown";
import {
  Close,
  Logout,
  Brightness4 as Brightness4Icon,
} from "@mui/icons-material";
import Skeleton from "@mui/material/Skeleton";
import Stack from "@mui/material/Stack";
import { setTheme, setFont } from "../redux/reducer/theme";
import { setLoading } from "../redux/action/loadingRequest";
import TextFieldsIcon from "@mui/icons-material/TextFields";
import PaletteIcon from "@mui/icons-material/Palette";
import Menu from "@mui/material/Menu"; // Add this import
import { saveUserTheme, fetchUserTheme } from "./stepper_form/stepper.helper";
import PersonIcon from "@mui/icons-material/Person";
import HistoryIcon from "@mui/icons-material/History";
import SearchIcon from "@mui/icons-material/Search";
import UploadFileIcon from "@mui/icons-material/UploadFile";
import DocumentScannerIcon from "@mui/icons-material/DocumentScanner";
import FindInPageIcon from "@mui/icons-material/FindInPage";
import PendingActionsIcon from "@mui/icons-material/PendingActions";

const drawerWidth = 240;

export default function DrawerAppBar(props) {
  const { window } = props;
  const [mobileOpen, setMobileOpen] = React.useState(false);
  const location = useLocation();
  const dispatch = useDispatch();
  const [anchorEl, setAnchorEl] = React.useState(null);
  const [openPophover, setopenPophover] = React.useState(false);
  const flagValue = useFeatureFlag("logohide");
  const CalculateButtonValue = useFeatureFlag("Calculate_Button_text");
  const MaintenanceMessage = useFeatureFlag("Maintenance_Break");
  const userType =
    useSelector((state) => state.userReducer?.type) || "copy-link";
  const demo_user_permission = useFeatureFlag("demo_user_permission");
  const Evaluate_user = useFeatureFlag("Evaluate_user");
  const { setAuthState, getAuthState } = React.useContext(OAuthCtx);
  const IncognitoModeStatus = useSelector(
    (state) => state.IncognitoMode?.IncognitoUser || false
  );
  const loading = useSelector((state) => state?.LoadingReducer?.state || false);
  const themes = useSelector((state) => state.themeReducer.themes);
  const currentTheme = useSelector((state) => state.themeReducer.currentTheme);
  const fonts = useSelector((state) => state.themeReducer.fonts);
  const currentFont = useSelector((state) => state.themeReducer.currentFont);
  const [anchorElFont, setAnchorElFont] = React.useState(null);
  const [anchorElTheme, setAnchorElTheme] = React.useState(null);
  const [savedTheme, setSavedTheme] = React.useState(null);
  const viewAsRecruiter = useSelector(
    (state) => state.userReducer.viewAsRecruiter
  );
  // console.log(viewAsRecruiter, "viewAsRecruiter-header");

  // Define routes where dropdowns should be visible
  const showDropdowns =
    location.pathname === "/Upload-Resume" ||
    location.pathname.startsWith("/candidate-profile/") ||
    location.pathname.startsWith("/public-profile/") ||
    location.pathname.startsWith("/resume-history/");

  const isPublicProfileRoute = location.pathname.startsWith("/public-profile/");
  const isLoggedIn =
    useSelector((state) => state.userReducer.isLoggedIn) || false;

  // const checkUser = async () => {
  //   try {
  //     const currentSession = await Auth.currentSession();
  //     await setAuthState(currentSession);
  //     setupAuthInterceptor(getAuthState);
  //     // dispatch(
  //     //   setUserStatus({
  //     //     isLoggedIn:
  //     //       sessionStorage.getItem("isLoggedIn") === "true" ? true : false,
  //     //     userRefId: sessionStorage.getItem("userRefId"),
  //     //     uniqueReferredUserId: sessionStorage.getItem("uniqueReferredUserId"),
  //     //     type: userType,
  //     //     uuid: sessionStorage.getItem("uuid"),
  //     //     viewAsRecruiter: viewAsRecruiter,
  //     //   })
  //     // );
  //     dispatch(setLoading(false));
  //   } catch (e) {}
  // };

  React.useEffect(() => {
    if (
      !localStorage.getItem(
        `CognitoIdentityServiceProvider.${process.env.REACT_APP_COGNITO_CLIENT_ID}.LastAuthUser`
      ) &&
      !sessionStorage.getItem("isLoggedIn")
    ) {
      // dispatch(setUserStatus({ isLoggedIn: false }));
    }
    // checkUser();
  }, []);

  React.useEffect(() => {
    const loadUserTheme = async () => {
      const themeData = await fetchUserTheme();
      if (themeData) {
        setSavedTheme(themeData);
        dispatch(setTheme(themeData.userTheme?.currentTheme || "default"));
        dispatch(setFont(themeData.userTheme?.font || "default"));
      }
    };
    loadUserTheme();
  }, []);

  const userEmail = getEmail();
  const uuid =
    useSelector((state) => state?.userReducer?.uuid) ||
    sessionStorage.getItem("uuid");

  const handleClick = (event) => {
    setAnchorEl(event.target);
    setopenPophover(true);
  };

  const handleClose = () => {
    setAnchorEl(null);
    setopenPophover(false);
  };

  const handleDrawerToggle = () => {
    setMobileOpen((prevState) => !prevState);
  };

  const navigate = useNavigate();
  const [openLogout, setOpenLogout] = React.useState(null);

  const handleModal = () => {
    setOpenLogout(true);
  };

  const handleCloseModal = () => {
    setOpenLogout(false);
  };

  const handleLogout = async () => {
    sessionStorage.clear();
    navigate("/signin");
    localStorage.clear();
    await Auth.signOut();
    dispatch(setUserStatus({ isLoggedIn: false }));
    sessionStorage.removeItem("isLogin");
    localStorage.removeItem("persist:root");
    setopenPophover(false);
    if (!sessionStorage.getItem("isLogin")) {
      navigate("/signin");
    }
  };

  const handleThemeChange = (themeKey) => {
    dispatch(setTheme(themeKey));
    saveUserTheme(`${themeKey}`, currentFont);
  };

  const handleFontChange = (fontKey, themeKey) => {
    dispatch(setFont(fontKey));
    saveUserTheme(`${themeKey}`, fontKey);
  };

  const handleFontMenuOpen = (event) => {
    setAnchorElFont(event.currentTarget);
  };

  const handleFontMenuClose = () => {
    setAnchorElFont(null);
  };

  const handleThemeMenuOpen = (event) => {
    setAnchorElTheme(event.currentTarget);
  };

  const handleThemeMenuClose = () => {
    setAnchorElTheme(null);
  };

  // Mobile menu drawer
  const drawer = (
    <Box sx={{ color: "#FDF9E0 !important", backgroundColor: "#000" }}>
      <Box sx={{ p: 2, textAlign: "center" }}>
        <img
          src={"/assets/images/TrueSelfy-logo(White).svg"}
          alt={"TrueSelfy Logo"}
          loading="lazy"
          style={{ maxWidth: "127px", maxHeight: "64px" }}
          onClick={() => navigate("/")}
        />
      </Box>
      <Divider sx={{ backgroundColor: "#FDF9E0" }} />
      <List sx={{ padding: "0px !important" }}>
        {isLoggedIn ? (
          <>
            {uuid && uuid !== "null" && viewAsRecruiter === false && (
              <ListItem>
                <ListItemButton
                  sx={{ textAlign: "center", padding: "0px !important" }}
                >
                  <PersonIcon sx={{ color: "#FDF9E0", mr: "10px" }} />
                  <ListItemText sx={{ textAlign: "left" }}>
                    <a
                      onClick={() => navigate(`/profile/${uuid}`)}
                      rel="noopener noreferrer"
                      style={{
                        display: "inline-block",
                        // backgroundColor: "#FDF9E0",
                        color: "#FDF9E0",
                        // borderRadius: "8px",
                        // padding: "6px 16px",
                        fontSize: "14px",
                        fontWeight: 600,
                        textDecoration: "none",
                      }}
                    >
                      Profile
                    </a>
                  </ListItemText>
                </ListItemButton>
              </ListItem>
            )}
            <ListItem>
              <ListItemButton
                sx={{ textAlign: "center", padding: "0px !important" }}
              >
                <HistoryIcon sx={{ color: "#FDF9E0", mr: "10px" }} />
                <ListItemText sx={{ textAlign: "left" }}>
                  <a
                    onClick={() => navigate("/resume-history")}
                    rel="noopener noreferrer"
                    style={{
                      display: "inline-block",
                      // backgroundColor: "#FDF9E0",
                      color: "#FDF9E0",
                      // borderRadius: "8px",
                      // padding: "6px 16px",
                      fontSize: "14px",
                      fontWeight: 600,
                      textDecoration: "none",
                    }}
                  >
                    Resume History
                  </a>
                </ListItemText>
              </ListItemButton>
            </ListItem>
            {isLoggedIn && viewAsRecruiter && (
              <ListItem>
                <ListItemButton
                  sx={{ textAlign: "center", padding: "0px !important" }}
                >
                  <SearchIcon sx={{ color: "#FDF9E0", mr: "10px" }} />
                  <ListItemText sx={{ textAlign: "left" }}>
                    <a
                      onClick={() => navigate("/advanced-data-search")}
                      rel="noopener noreferrer"
                      style={{
                        display: "inline-block",
                        // backgroundColor: "#FDF9E0",
                        color: "#FDF9E0",
                        // borderRadius: "8px",
                        // padding: "6px 16px",
                        fontSize: "14px",
                        fontWeight: 600,
                        textDecoration: "none",
                      }}
                    >
                      Advanced Data Search
                    </a>
                  </ListItemText>
                </ListItemButton>
              </ListItem>
            )}
            {isLoggedIn && viewAsRecruiter && (
              <ListItem>
                <ListItemButton
                  sx={{ textAlign: "center", padding: "0px !important" }}
                >
                  <FindInPageIcon sx={{ color: "#FDF9E0", mr: "10px" }} />
                  <ListItemText sx={{ textAlign: "left" }}>
                    <a
                      onClick={() => navigate("/advanced-jd-search")}
                      style={{
                        display: "inline-block",
                        // backgroundColor: "#FDF9E0",
                        color: "#FDF9E0",
                        // borderRadius: "8px",
                        // padding: "6px 16px",
                        fontSize: "14px",
                        fontWeight: 600,
                        textDecoration: "none",
                      }}
                    >
                      JD Ranker
                    </a>
                  </ListItemText>
                </ListItemButton>
              </ListItem>
            )}
            {isLoggedIn && viewAsRecruiter && (
              <ListItem>
                <ListItemButton
                  sx={{ textAlign: "center", padding: "0px !important" }}
                >
                  <DocumentScannerIcon sx={{ color: "#FDF9E0", mr: "10px" }} />
                  <ListItemText sx={{ textAlign: "left" }}>
                    <a
                      onClick={() => navigate("/resume-ranker")}
                      style={{
                        display: "inline-block",
                        // backgroundColor: "#FDF9E0",
                        color: "#FDF9E0",
                        // borderRadius: "8px",
                        // padding: "6px 16px",
                        fontSize: "14px",
                        fontWeight: 600,
                        textDecoration: "none",
                      }}
                    >
                      Resume Ranker (File Based)
                    </a>
                  </ListItemText>
                </ListItemButton>
              </ListItem>
            )}
            {isLoggedIn && viewAsRecruiter && (
              <ListItem>
                <ListItemButton
                  sx={{ textAlign: "center", padding: "0px !important" }}
                >
                  <PendingActionsIcon sx={{ color: "#FDF9E0", mr: "10px" }} />
                  <ListItemText sx={{ textAlign: "left" }}>
                    <a
                      onClick={() => navigate("/pending-resumes")}
                      // href="/pending-resumes"
                      style={{
                        display: "inline-block",
                        // backgroundColor: "#FDF9E0",
                        color: "#FDF9E0",
                        // borderRadius: "8px",
                        // padding: "6px 16px",
                        fontSize: "14px",
                        fontWeight: 600,
                        textDecoration: "none",
                      }}
                    >
                      Pending Resumes
                    </a>
                  </ListItemText>
                </ListItemButton>
              </ListItem>
            )}
            {location.pathname !== "/Upload-Resume" && ( // Hide if already on the route
              <ListItem>
                <ListItemButton
                  sx={{ textAlign: "center", padding: "0px !important" }}
                >
                  <UploadFileIcon sx={{ color: "#FDF9E0", mr: "10px" }} />
                  <ListItemText sx={{ textAlign: "left" }}>
                    <a
                      // href="/Upload-Resume"
                      onClick={() => navigate("/Upload-Resume")}
                      style={{
                        display: "inline-block",
                        // backgroundColor: "#FDF9E0",
                        color: "#FDF9E0",
                        // borderRadius: "8px",
                        // padding: "6px 16px",
                        fontSize: "14px",
                        fontWeight: 600,
                        textDecoration: "none",
                      }}
                    >
                      Upload Resume
                    </a>
                  </ListItemText>
                </ListItemButton>
              </ListItem>
            )}
            <Divider sx={{ backgroundColor: "#FDF9E0" }} />
            <ListItem>
              <ListItemButton
                sx={{ textAlign: "center", padding: "0px !important" }}
              >
                <ListItemText>
                  <Button
                    variant="outlined"
                    sx={{
                      // backgroundColor: "#FDF9E0",
                      color: "#FDF9E0",
                      // borderRadius: "8px",
                      // padding: "6px 16px",
                      fontSize: "14px",
                      fontWeight: 600,
                      textTransform: "none",
                      "&:hover": { backgroundColor: "#26801E" },
                    }}
                    onClick={handleModal}
                  >
                    Logout
                  </Button>
                </ListItemText>
              </ListItemButton>
            </ListItem>
          </>
        ) : loading ? (
          <>
            <ListItem>
              <ListItemButton
                sx={{
                  textAlign: "center",
                  padding: "0px",
                  justifyContent: "center",
                }}
              >
                <Stack spacing={1}>
                  <Skeleton
                    variant="square"
                    width={80}
                    height={32}
                    sx={{
                      backgroundColor: "rgb(119 119 119)",
                      borderRadius: "8px",
                    }}
                  />
                </Stack>
              </ListItemButton>
            </ListItem>
          </>
        ) : (
          <ListItem onClick={() => navigate("/signin")}>
            <ListItemButton sx={{ textAlign: "center", padding: "0px" }}>
              <ListItemText p={0}>
                <Button
                  variant="outlined"
                  sx={{
                    // backgroundColor: "#FDF9E0",
                    color: "#FDF9E0",
                    // borderRadius: "8px",
                    // padding: "6px 16px",
                    fontSize: "14px",
                    fontWeight: 600,
                    textTransform: "none",
                    "&:hover": { backgroundColor: "#26801E" },
                  }}
                  onClick={() => navigate("/signin")}
                >
                  Sign In
                </Button>
              </ListItemText>
            </ListItemButton>
          </ListItem>
        )}
      </List>
    </Box>
  );

  const container =
    window !== undefined ? () => window().document.body : undefined;

  const logohide = flagValue ? (
    ""
  ) : (
    <Box>
      <Link href="/" sx={{ display: "flex", alignItems: "center" }}>
        <img
          style={{ maxWidth: "127px", maxHeight: "64px" }}
          src={"/assets/images/TrueSelfy-logo(White).svg"}
          alt={"TrueSelfy Logo"}
          loading="lazy"
        />
      </Link>
    </Box>
  );

  return (
    <>
      <CssBaseline />
      {/* Desktop menu */}
      <AppBar
        component="nav"
        elevation={0}
        sx={{
          background: "none !important", // Black background
          color: "#FFF !important", // White text/icons
          padding: {
            xs: "10px",
            sm: "10px",
            md: "10px",
            lg: "10px 20px",
            xl: "10px 80px",
          },
          position: "fixed",
          top: 0,
          right: 0,
          width: "100%",
          zIndex: 99,
        }}
      >
        <Toolbar
          sx={{
            display: "flex",
            alignItems: "center",
            justifyContent: "space-between",
          }}
        >
          {/* Mobile Menu Icon */}
          <IconButton
            aria-label="open drawer"
            edge="start"
            onClick={handleDrawerToggle}
            sx={{ display: { md: "none", lg: "none" }, color: "#FFF" }}
          >
            <MenuIcon />
          </IconButton>

          {/* Mobile Logo */}
          <Box
            sx={{
              display: { xs: "block", sm: "block", md: "none", lg: "none" },
              flexGrow: 1,
              textAlign: "center",
            }}
          >
            <img
              src={"/assets/images/TrueSelfy-logo(White).svg"}
              alt={"TrueSelfy Logo"}
              loading="lazy"
              style={{ maxWidth: "80px" }}
              onClick={() => navigate("/")}
            />
          </Box>

          {/* Desktop Logo */}
          <Box
            sx={{
              display: { xs: "none", sm: "none", md: "block", lg: "block" },
            }}
          >
            {logohide}
          </Box>

          {/* Login Section */}
          {!isLoggedIn && loading === false ? (
            <Box sx={{ display: "flex", alignItems: "center" }}>
              {isPublicProfileRoute && !isLoggedIn && (
                <Box>
                  {/* Typography Dropdown */}
                  <IconButton
                    onClick={handleFontMenuOpen}
                    sx={{
                      color: themes[currentTheme]?.primary || "#FFF",
                      marginRight: { xs: 0, md: 2 },
                    }}
                  >
                    <TextFieldsIcon />
                  </IconButton>
                  <Menu
                    anchorEl={anchorElFont}
                    open={Boolean(anchorElFont)}
                    onClose={handleFontMenuClose}
                  >
                    {Object.keys(fonts).map((fontKey) => (
                      <MenuItem
                        key={fontKey}
                        onClick={() => {
                          handleFontChange(fontKey, currentTheme);
                          handleFontMenuClose();
                        }}
                        sx={{ fontFamily: fonts[fontKey] }}
                      >
                        {fontKey.charAt(0).toUpperCase() + fontKey.slice(1)}
                      </MenuItem>
                    ))}
                  </Menu>

                  {/* Theme Color Dropdown */}
                  <IconButton
                    onClick={handleThemeMenuOpen}
                    sx={{
                      color: themes[currentTheme]?.primary || "#FFF",
                      marginRight: { xs: 0, md: 2 },
                    }}
                  >
                    <PaletteIcon />
                  </IconButton>
                  <Menu
                    anchorEl={anchorElTheme}
                    open={Boolean(anchorElTheme)}
                    onClose={handleThemeMenuClose}
                  >
                    {Object.keys(themes).map((themeKey) => (
                      <MenuItem
                        key={themeKey}
                        onClick={() => {
                          handleThemeChange(themeKey);
                          handleThemeMenuClose();
                        }}
                        sx={{
                          display: "flex",
                          alignItems: "center",
                          gap: 1,
                        }}
                      >
                        <Box
                          sx={{
                            width: 16,
                            height: 16,
                            borderRadius: "50%",
                            backgroundColor: themes[themeKey]?.primary,
                          }}
                        />
                        {themeKey.charAt(0).toUpperCase() + themeKey.slice(1)}
                      </MenuItem>
                    ))}
                  </Menu>
                </Box>
              )}
              <Box
                sx={{
                  display: {
                    xs: "none",
                    sm: "none",
                    md: "block",
                    lg: "block",
                  },
                  alignItems: "center",
                  gap: 1,
                }}
              >
                {/* <IconButton sx={{ color: "#FFF" }}>
                <Brightness4Icon />
              </IconButton> */}
                <Button
                  variant="contained"
                  sx={{
                    backgroundColor: "#FDF9E0",
                    color: "#000",
                    borderRadius: "8px",
                    padding: "6px 16px",
                    fontSize: "14px",
                    fontWeight: 600,
                    textTransform: "none",
                    "&:hover": { backgroundColor: "#E0E0E0" },
                  }}
                  onClick={() => navigate("/signin")}
                >
                  Sign In
                </Button>
              </Box>
            </Box>
          ) : loading ? (
            <Stack spacing={1}>
              <Skeleton
                variant="circular"
                sx={{ backgroundColor: "rgb(119 119 119)" }}
                width={40}
                height={40}
              />
            </Stack>
          ) : (
            <Box sx={{ display: "flex" }}>
              {showDropdowns && (
                <Box>
                  {/* Typography Dropdown */}
                  <IconButton
                    onClick={handleFontMenuOpen}
                    sx={{
                      color: themes[currentTheme]?.primary || "#FFF",
                      marginRight: { xs: 0, md: 2 },
                    }}
                  >
                    <TextFieldsIcon />
                  </IconButton>
                  <Menu
                    anchorEl={anchorElFont}
                    open={Boolean(anchorElFont)}
                    onClose={handleFontMenuClose}
                  >
                    {Object.keys(fonts).map((fontKey) => (
                      <MenuItem
                        key={fontKey}
                        onClick={() => {
                          handleFontChange(fontKey, currentTheme);
                          handleFontMenuClose();
                        }}
                        sx={{ fontFamily: fonts[fontKey] }}
                      >
                        {fontKey.charAt(0).toUpperCase() + fontKey.slice(1)}
                      </MenuItem>
                    ))}
                  </Menu>

                  {/* Theme Color Dropdown */}
                  <IconButton
                    onClick={handleThemeMenuOpen}
                    sx={{
                      color: themes[currentTheme]?.primary || "#FFF",
                      marginRight: { xs: 0, md: 2 },
                    }}
                  >
                    <PaletteIcon />
                  </IconButton>
                  <Menu
                    anchorEl={anchorElTheme}
                    open={Boolean(anchorElTheme)}
                    onClose={handleThemeMenuClose}
                  >
                    {Object.keys(themes).map((themeKey) => (
                      <MenuItem
                        key={themeKey}
                        onClick={() => {
                          handleThemeChange(themeKey);
                          handleThemeMenuClose();
                        }}
                        sx={{
                          display: "flex",
                          alignItems: "center",
                          gap: 1,
                        }}
                      >
                        <Box
                          sx={{
                            width: 16,
                            height: 16,
                            borderRadius: "50%",
                            backgroundColor: themes[themeKey]?.primary,
                          }}
                        />
                        {themeKey.charAt(0).toUpperCase() + themeKey.slice(1)}
                      </MenuItem>
                    ))}
                  </Menu>
                </Box>
              )}

              <UserDropdown
                handleLogout={handleLogout}
                Evaluate_user={Evaluate_user}
                isLoggedIn={isLoggedIn}
              />
            </Box>
          )}

          {/* Logout Modal */}
          <Modal
            open={openLogout}
            aria-labelledby="logout-modal-title"
            aria-describedby="logout-modal-description"
          >
            <Box
              sx={{
                position: "absolute",
                top: "50%",
                left: "50%",
                transform: "translate(-50%, -50%)",
                width: 300,
                bgcolor: "#FDF9E0",
                border: "2px solid #000",
                boxShadow: 24,
                p: 4,
              }}
            >
              <Grid
                container
                justifyContent="space-between"
                alignItems="center"
              >
                <Typography
                  id="logout-modal-title"
                  variant="h6"
                  component="h2"
                  sx={{ fontWeight: 600 }}
                >
                  Confirm Logout
                </Typography>
                <IconButton onClick={handleCloseModal}>
                  <Close />
                </IconButton>
              </Grid>
              <Typography
                id="logout-modal-description"
                sx={{ mt: 2, fontWeight: 600 }}
              >
                Are you sure you want to logout?
              </Typography>
              <Grid container justifyContent="space-between" sx={{ mt: 4 }}>
                <Button
                  sx={{
                    borderRadius: "55px",
                    fontSize: "16px",
                    fontWeight: 600,
                  }}
                  onClick={() => {
                    handleLogout();
                    setOpenLogout(false);
                  }}
                  variant="contained"
                  color="primary"
                >
                  Yes
                </Button>
                <Button
                  onClick={handleCloseModal}
                  variant="outlined"
                  color="#000"
                  sx={{
                    borderRadius: "55px",
                    fontSize: "16px",
                    fontWeight: 600,
                  }}
                >
                  No
                </Button>
              </Grid>
            </Box>
          </Modal>
        </Toolbar>
      </AppBar>

      {/* Mobile Drawer */}
      <Box component="nav">
        <Drawer
          container={container}
          variant="temporary"
          open={mobileOpen}
          onClose={handleDrawerToggle}
          ModalProps={{ keepMounted: true }}
          sx={{
            display: { xs: "block", md: "none", lg: "none" },
            "& .MuiDrawer-paper": {
              boxSizing: "border-box",
              width: drawerWidth,
              backgroundColor: "#000",
              color: "#FFF",
            },
          }}
        >
          {drawer}
        </Drawer>
      </Box>
    </>
  );
}
